export const ONE_KILOMETER_IN_MILES = 0.6213711922
export const ONE_MILE_IN_KILOMETERS = 1.609344
